import { Tree } from "primereact/tree";

export function CustomTree({ values, selectionKeys, onSelectionChange }) {
    return <Tree selectionMode="checkbox" className="border-none" value={values} selectionKeys={selectionKeys} onSelectionChange={onSelectionChange} />;
}
